import type { FirebaseConfigType } from './type';

export const FirebaseConfig: FirebaseConfigType = {
  apiKey: 'AIzaSyBjey37E19jOqMbmQv5ZKM2GdDatZzA93E',
  authDomain: 'levii-balus-local.firebaseapp.com',
  databaseURL: 'https://levii-balus-local.firebaseio.com',
  projectId: 'levii-balus-local',
  storageBucket: 'levii-balus-local.appspot.com',
  messagingSenderId: '1038545176134',
  appId: '1:1038545176134:web:b4269e2f44ebbbdd46ec47',
  measurementId: 'G-K5VGKRTQJT',
};
